import { styled } from '@mui/material';

export const StyledRootDiv = styled('div', {
  shouldForwardProp: prop => prop !== 'shouldDisplayGrayBg',
})<{ shouldDisplayGrayBg: boolean }>(({ theme, shouldDisplayGrayBg }) => ({
  position: 'fixed',
  padding: theme.spacing(3),
  backgroundColor: shouldDisplayGrayBg ? 'transparent' : theme.palette.white,
  width: '100%',
  bottom: 0,
}));

export const StyledSeparator = styled('span')(({ theme }) => ({
  margin: `0px ${theme.spacing(3)}px`,
  color: 'silver',
}));